import { DocumentScannerConstants } from './documentScanner.constants'
import { IDocumentScannerAction, IDocumentScannerState } from './documentScanner.types'

export const initialDocumentScannerState: IDocumentScannerState = {
  scannedDocuments: [],
  documentAttachments: [],
  disableScanButton: true,
  documentAttachmentToDelete: null,
}

const MAX_DOCUMENT_ATTACHMENTS = 5

export const getMaximumDocumentAttachments = (): number => {
  return MAX_DOCUMENT_ATTACHMENTS
}

export function documentScannerReducer(
  state: IDocumentScannerState = initialDocumentScannerState,
  action: IDocumentScannerAction
): IDocumentScannerState {
  switch (action.type) {
    case DocumentScannerConstants.SET_SCANNED_DOCUMENTS:
      return { ...state, scannedDocuments: action.scannedDocuments }
    case DocumentScannerConstants.SET_DOCUMENT_ATTACHMENTS:
      return { ...state, documentAttachments: action.documentAttachments }
    case DocumentScannerConstants.SET_DISABLE_SCAN_BUTTON:
      return { ...state, disableScanButton: action.disableScanButton }
    case DocumentScannerConstants.DELETE_DOCUMENT_ATTACHMENT:
      return { ...state, documentAttachmentToDelete: action.documentAttachmentToDelete }
    case DocumentScannerConstants.RESET_DOCUMENT_SCANNER_STATE:
      return {
        ...state,
        scannedDocuments: [],
        documentAttachments: [],
        disableScanButton: true,
        documentAttachmentToDelete: null,
      }
    default:
      return state
  }
}
